import React, {useCallback, useMemo, useState} from 'react';

import {useWorkspaceCriteria} from 'src/modules/profile/user/tabs/content/workspace/hooks/useWorkspaceCriteria';
import {
    SCOPE_KEY,
    WorkspaceOwnershipFilter,
    WorkspaceOwnershipFilterLabel,
    collaboratorRolesToOwnership, mapWorkspaceOwnershipFilterToCollaboratorRoles,
} from 'src/modules/profile/user/tabs/content/workspace/util';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {SortHeaderFilter} from '@pb/kit-component-filters';
import Label from '@pb/kit-component-label';
import {Cell} from '@pb/kit-component-table';

export const CollaboratorRoleHeader = () => {
    const {criteria, setCriteria: onUpdate} = useWorkspaceCriteria(SCOPE_KEY);

    const [request, setRequest] = useState<WorkspaceOwnershipFilter>(WorkspaceOwnershipFilter.ALL);

    const currentValue = useMemo(() => (
        criteria?.ownerFilter && collaboratorRolesToOwnership(criteria.ownerFilter) !== WorkspaceOwnershipFilter.ALL
            ? collaboratorRolesToOwnership(criteria.ownerFilter)
            : request
    ), [criteria?.ownerFilter, request]);

    const onCancel = useCallback(() => (
        setRequest(criteria?.ownerFilter
            ? collaboratorRolesToOwnership(criteria.ownerFilter)
            : WorkspaceOwnershipFilter.ALL)
    ), [criteria?.ownerFilter, setRequest]);

    return (
        <Cell width={150}>
            <SortHeaderFilter
                caption="Collaborator Role"
                filterActive={
                    criteria?.ownerFilter
                        ? collaboratorRolesToOwnership(criteria.ownerFilter) !== WorkspaceOwnershipFilter.ALL
                        : undefined
                }
                onCancel={onCancel}
                sortable={false}
                defaultDirection="ASC"
                onReset={() => {
                    setRequest(WorkspaceOwnershipFilter.ALL);
                    onUpdate({
                        ownerFilter: mapWorkspaceOwnershipFilterToCollaboratorRoles(WorkspaceOwnershipFilter.ALL),
                    });
                }}
                onApply={() => {
                    onUpdate({
                        ownerFilter: mapWorkspaceOwnershipFilterToCollaboratorRoles(request),
                    });
                }}>
                <div>
                    <Label>Owner role</Label>
                    <ComboBox<WorkspaceOwnershipFilter, WorkspaceOwnershipFilter>
                        value={currentValue}
                        onChange={setRequest}
                        placeholder="Select item type">
                        <ComboboxItem
                            caption={WorkspaceOwnershipFilterLabel.USER}
                            value={WorkspaceOwnershipFilter.USER}
                        />
                        <ComboboxItem
                            caption={WorkspaceOwnershipFilterLabel.SHARED}
                            value={WorkspaceOwnershipFilter.SHARED}
                        />
                    </ComboBox>
                </div>
            </SortHeaderFilter>
        </Cell>
    );
};
